<template>
    <vue-tel-input
        v-model="value"
        :mode="modelMode"
        :styleClasses="modelStyleClasses"
        :inputOptions="inputOptions"
        :autoDefaultCountry="!!autoDefaultCountry"
    ></vue-tel-input>
</template>

<script>
import {VueTelInput} from 'vue-tel-input'

export default {
    name: "IntlPhoneInput",
    components: {
        VueTelInput,
    },
    props: {
        'initialValue': String,
        'name': String,
        'id': String,
        'maxlength': Number,
        'required': Boolean,
        'mode': String,
        'styleClasses': String,
        'autoDefaultCountry': {
            type: Number,
            default: 1,
        },
    },
    data: function () {
        return {
            value: '',
            inputOptions: {
                name: '',
                autocomplete: 'on',
                placeholder: '',
                id: '',
                maxlength: 25,
                readonly: false,
                required: false,
                type: 'tel'
            },
            modelMode: '',
            modelStyleClasses: '',

        }
    },
    mounted() {
        // console.log(this.autoDefaultCountry);
        this.modelStyleClasses = this.styleClasses
        this.modelMode = this.mode
        this.value = this.initialValue

        this.inputOptions.name = this.name
        this.inputOptions.autocomplete = this.autocomplete
        this.inputOptions.placeholder = this.placeholder
        this.inputOptions.id = this.id
        this.inputOptions.maxlength = this.maxlength

        this.inputOptions.readonly = this.readonly
        this.inputOptions.required = this.required
    }

}
</script>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>
